import {api} from '@/http'

// 站内信列表
const getLetterList = (data, callback, back) => {
  api('/api/letter', 'get', data, callback, back)
}

// 订阅消息列表
const getOrderList = (data, callback, back) => {
  api('/api/subscription', 'get', data, callback, back)
}

// 面试详情-消息中心
const getLetterDesc = (id, callback, back) => {
  api('/api/letter/' + id, 'get', '', callback, back)
}

// 面试详情
const getInterviewDesc = (id, callback, back) => {
  api('/api/interview/' + id, 'get', '', callback, back)
}

// 订阅消息列表
const getOrderPositionList = (id, data, callback, back) => {
  api('/api/subscription/' + id + '/position', 'get', data, callback, back)
}

// 面试删除
const delLetter = (id, callback, back) => {
  api('/api/letter/' + id, 'del', '', callback, back)
}

// 推送删除
const delPush = (id, callback, back) => {
  api('/api/subscription/' + id, 'del', '', callback, back)
}

// 消息已读
const setReadAll = (type, callback, back) => {
  api('/api/' + type + '/set_read', 'post', '', callback, back)
}

// 参加面试
const interviewJoin = (id, data, callback, back) => {
  api('/api/interview/' + id + '/set_join', 'post', data, callback, back)
}

// 面试结果
const interviewResult = (id, data, callback, back) => {
  api('/api/interview/' + id + '/set_interview_status', 'post', data, callback, back)
}

export default {
  interviewResult,
  getLetterList,
  getOrderList,
  getLetterDesc,
  getOrderPositionList,
  delLetter,
  delPush,
  setReadAll,
  interviewJoin,
  getInterviewDesc
}



// WEBPACK FOOTER //
// ./src/api/message/index.js